// extracted by mini-css-extract-plugin
module.exports = {"block":"Tool_block_2U5uD","item":"Tool_item_3xj4Y","iconBlock":"Tool_iconBlock_RKH9X","socialList":"Tool_socialList_2R8RY"};